import { Injectable, Inject } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment-wrapper';

@Injectable()
export class MetaTagService {

   constructor(private titleService: Title,
              private metaTagService: Meta,
              private translateService: TranslateService,
              @Inject(DOCUMENT) private document) {}

  private _domain = environment.cdnServerUrl.slice(0, -1); // Remove the trailing slash

  public async setPageTitle(translationName: string, variables: {}) {
    variables = await this._formatVariableData(variables);
    this.translateService.get(translationName, variables).toPromise().then((title) => this.titleService.setTitle(title));
  }

  public async setPageDescription(translationName: string, variables: {}) {
    variables = await this._formatVariableData(variables);
    this.translateService.get(translationName, variables).toPromise().then((description) => this.metaTagService.updateTag({name: 'description', content: description}));
  }

  public async addPageThumbnail(name, content) {
    this.metaTagService.addTag({name, content})
  }

  /**
   * @param metaDefinition the attributes you want to define for your meta tag
   */
  public addMetaTagToDOM(metaDefinition: MetaDefinition) {
    this.metaTagService.addTag(metaDefinition);
  }

  /**
   * @param attribute the attribute on the element that determines which meta tag to remove from the DOM
   */
  public removeMetaTagFromDOM(attribute: string) {
    this.metaTagService.removeTag(attribute);
  }

  // [MBL-2738] - Getting the meta tag by attribute, for this ticket, added to get
  // the meta tag with the attribute name="description" for the product schema
  public getMetaTagAttr(key) {
    return this.metaTagService.getTag(key);
  }

  /**
   * Use this to set the relevant Open Graph Tags if necessary
   * @param variables an array of the open graph tags we want to set
   */
  public async setOpenGraphTags(variables: OpenGraphTag[]) {
    if (!variables) return;
    for (const tag of variables) {
      const name = (tag.prefixName || 'og') + ':' + tag.name;
      if (tag.isTranslateKey) {
        this.translateService.get(tag.content, tag.variables).toPromise().then((description) => this.metaTagService.updateTag({property: name, content: description}));
      }
      else if (tag.name === 'url') this.metaTagService.updateTag({property: name, content: this._domain + tag.content});
      else this.metaTagService.updateTag({property: name, content: tag.content});
    }
  }


  private async _formatVariableData(variables: {} ) {
    if (variables) {
      if (variables['province']) variables['province'] = await this.translateService.get('provinces.' + variables['province']).toPromise();
      if (variables['city']) variables['city'] = variables['city'].charAt(0).toUpperCase() + variables['city'].slice(1);
      if (variables['propType']) variables['propType'] = variables['propType'].charAt(0).toUpperCase() + variables['propType'].slice(1);
    }
    return variables;
  }
}

export class OpenGraphTag {
  name: string;
  content: string;
  isTranslateKey?: boolean;
  variables?: {}; // Only used when isTranslateKey = true,
  prefixName?: string = 'og'; // When we want to use a prefix thats not for open graph
}
